
// //---------------------------------------------------------
// import React, { useState, useEffect } from 'react';
// import { Country, State, City } from "country-state-city";
// import '../Styles/RegisterAdmin.css';
// import axios from 'axios';

// const RegisterAdmin = () => {
//   const [formData, setFormData] = useState({
//     companyName: '',
//     fullName: '',
//     phoneNumber: '',
//     whatsappNumber: '',
//     emailAddress: '',
//     referredBy: '',
//     country: '',
//     state: '',
//     district: '',
//     city: '',
//     address: '',
//     locality: '',
//     primaryBusiness: '',
//     secondaryBusiness: '',
//    // pincode: '',
//     nearestAirport: '',
//     monthlyBusiness: '',
//     secondaryMonthlyBusiness: '',
//     companyTradeLicense: null,
//     vatRegistrationNumber: '',
//     onlineOTAs: '',
//     seriesOTAs: '',
//   });

//   const [countries, setCountries] = useState([]);
//   const [states, setStates] = useState([]);
//   const [cities, setCities] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [message, setMessage] = useState('');

//   useEffect(() => {
//     const allCountries = Country.getAllCountries();
//     setCountries(allCountries);
//   }, []);

//   const handleCountryChange = (e) => {
//     const selectedCountryCode = e.target.value;
//     setFormData({ ...formData, country: selectedCountryCode, state: '', city: '' });

//     const selectedStates = State.getStatesOfCountry(selectedCountryCode);
//     setStates(selectedStates);
//     setCities([]);
//   };

//   const handleStateChange = (e) => {
//     const selectedStateCode = e.target.value;
//     setFormData({ ...formData, state: selectedStateCode, city: '' });

//     const selectedCities = City.getCitiesOfState(formData.country, selectedStateCode);
//     setCities(selectedCities);
//   };

//   const handleCityChange = (e) => {
//     const selectedCity = e.target.value;
//     setFormData((prev) => ({ ...prev, city: selectedCity }));
//   };

//   const handleInputChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleFileChange = (event) => {
//     const { name, files } = event.target;
//     const file = files[0];
//     setFormData({
//       ...formData,
//       [name]: file ? file : null,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     setMessage('');

//     const submitData = new FormData();
//     Object.keys(formData).forEach((key) => {
//       if (key === 'companyTradeLicense') {
//         if (formData[key]) {
//           submitData.append(key, formData[key]);
//         } else {
//           alert(`${key} is required.`);
//           setIsSubmitting(false);
//           return;
//         }
//       } else {
//         submitData.append(key, formData[key]);
//       }
//     });

//     try {
//       const response = await axios.post(
//         //https://b2bdubaibackendapi.mmstourism.com
//         'https://b2bdubaibackendapi.mmstourism.com/api/b2/agency/register-agency',
//         submitData,
//         {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//           },
//         }
//       );

//       if (formData.phoneNumber === response.data.phoneNumber) {
//         setMessage('Company already exists with this phone number.');
//         setIsSubmitting(false);
//         return;
//       }

//       if (response.data && response.data.error === 'Company already exists') {
//         alert('Company already exists.');
//         setIsSubmitting(false);
//         return;
//       }

//       alert('Registration successful!');
//       setFormData({
//         companyName: '',
//         fullName: '',
//         phoneNumber: '',
//         whatsappNumber: '',
//         emailAddress: '',
//         referredBy: '',
//         country: '',
//         state: '',
//         district: '',
//         city: '',
//         address: '',
//         locality: '',
//         primaryBusiness: '',
//         secondaryBusiness: '',
//        // pincode: '',
//         nearestAirport: '',
//         monthlyBusiness: '',
//         secondaryMonthlyBusiness: '',
//         companyTradeLicense: null,
//         vatRegistrationNumber: '',
//         onlineOTAs: '',
//         seriesOTAs: '',
//       });

//     } catch (error) {
//       alert('Company already exists.');
//       console.error('API Error:', error);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="register-body">
//       <div className="registration-form">
//         <h2>Agency Sign Up Form</h2>
//         <p className="note">Fields marked with <span className="required">*</span> are mandatory</p>
//         <form onSubmit={handleSubmit}>
//           <div className="form-row">
//             <div className="form-register-group">
//               <label>Company Name <span className="required">*</span></label>
//               <input type="text" name="companyName" value={formData.companyName} onChange={handleInputChange} required />
//             </div>
//             <div className="form-register-group">
//               <label>Full Name <span className="required">*</span></label>
//               <input type="text" name="fullName" value={formData.fullName} onChange={handleInputChange} required />
//             </div>
//           </div>

//           <div className="form-row">
//             <div className="form-register-group">
//               <label>Phone Number <span className="required">*</span></label>
//               <input type="text" name="phoneNumber" value={formData.phoneNumber} onChange={handleInputChange} required />
//             </div>
//             <div className="form-register-group">
//               <label>WhatsApp Number <span className="required">*</span></label>
//               <input type="text" name="whatsappNumber" value={formData.whatsappNumber} onChange={handleInputChange} required />
//             </div>
//           </div>

//           <div className="form-row">
//             <div className="form-register-group">
//               <label>Email Address <span className="required">*</span></label>
//               <input type="email" name="emailAddress" value={formData.emailAddress} onChange={handleInputChange} required />
//             </div>
//             <div className="form-register-group">
//               <label>Referred By <span className="required">*</span></label>
//               <select name="referredBy" value={formData.referredBy} onChange={handleInputChange} required>
//                 <option value="">Select</option>
//                 <option value="agency">Agency</option>
//                 <option value="website">Website</option>
//               </select>
//             </div>
//           </div>

//           <div className="form-row">
//             <div className="form-register-group">
//               <label>Country <span className="required">*</span></label>
//               <select name="country" value={formData.country} onChange={handleCountryChange} required>
//                 <option value="">Select Country</option>
//                 {countries.map((country) => (
//                   <option key={country.isoCode} value={country.isoCode}>
//                     {country.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div className="form-register-group">
//               <label>State <span className="required">*</span></label>
//               <select name="state" value={formData.state} onChange={handleStateChange} required>
//                 <option value="">Select State</option>
//                 {states.map((state) => (
//                   <option key={state.isoCode} value={state.isoCode}>
//                     {state.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div className="form-register-group">
//               <label>City <span className="required">*</span></label>
//               <select name="city" value={formData.city} onChange={handleCityChange} required>
//                 <option value="">Select City</option>
//                 {cities.map((city) => (
//                   <option key={city.name} value={city.name}>
//                     {city.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Continue with other form fields here as in your original code... */}
          
//            <div className="form-row">
//              <div className="form-register-group">
//                <label>Address <span className="required">*</span></label>
//                <input type="text" name="address" value={formData.address} placeholder='Address'onChange={handleInputChange} required />
//              </div>
//              <div className="form-register-group">
//                <label>Specify your locality <span className="required">*</span></label>
//                <input type="text" name="locality" value={formData.locality} placeholder='Locality'onChange={handleInputChange} required />
//              </div>
            
//            </div>

//            <div className="form-row">
//              <div className="form-register-group">
//                <label>Primary Business<span className="required">*</span></label>
//                <select type="text" name="primaryBusiness" value={formData.primaryBusiness} onChange={handleInputChange} required >
//                  <option value = "">Select Primary Business Type</option>
//                  <option value = "Flight Ticket">Flight Ticket</option>
//                  <option value = "Railway Ticket">Railway Ticket</option>
//                  <option value = "Domestic Tour">Domestic Tour</option>
//                  <option value = "International Tour">International Tour</option>
//                </select>
//              </div>
//              <div className="form-register-group">
//                <label>Monthly Business 
//                  <span className="required">*</span>
//                </label>
//                <select name="monthlyBusiness" value={formData.monthlyBusiness} onChange={handleInputChange} required >
//                  <option value ="">Select</option>
//                  <option value ="Below USD 5000/-">Below USD 5000/-</option>
//                  <option value ="USD 5000/-TO 15000/-">USD 5000/-TO 15000/-</option>
//                  <option value ="USD 15000/-TO 25000/-">USD 15000/-TO 25000/-</option>
//                  <option value ="Above 25000/- AND ABOVE">Above 25000/- AND ABOVE</option>
//                </select>
//              </div>
//            </div>

//            <div className="form-row">
//              <div className="form-register-group">
//                <label>Secondary Business
//                  {/* <span className="required">*</span> */}
//                  </label>
//                <select type="text" name="secondaryBusiness" value={formData.secondaryBusiness} onChange={handleInputChange}>
//                  <option value = "">Select Secondary Business Type</option>
//                  <option value = "Flight Ticket">Flight Ticket</option>
//                  <option value = "Railway Ticket">Railway Ticket</option>
//                  <option value = "Domestic Tour">Domestic Tour</option>
//                  <option value = "International Tour">International Tour</option>
//                  <option value = "none">None</option>
//                </select>
//              </div>
//              <div className="form-register-group">
//                <label>Monthly Business
//                   {/* <span className="required">*</span> */}
//                   </label>
//                <select name="secondaryMonthlyBusiness" value={formData.secondaryMonthlyBusiness} onChange={handleInputChange}  >
//                  <option value ="">Select</option>
//                  {/* <option value ="Below 5 lacs">Below 5 Lacs</option>
//                  <option value ="5 - 10 Lacs">5 - 10 Lacs</option>
//                  <option value ="11 - 25 Lacs">11 - 25 Lacs</option>
//                  <option value ="Above 25 Lacs">Above 25 Lacs</option> */}
//                   <option value ="Below USD 5000/-">Below USD 5000/-</option>
//                <option value ="USD 5000/-TO 15000/-">USD 5000/-TO 15000/-</option>
//                  <option value ="USD 15000/-TO 25000/-">USD 15000/-TO 25000/-</option>
//                  <option value ="Above 25000/- AND ABOVE">Above 25000/- AND ABOVE</option>
//                </select>
//              </div>
//           </div>
//           <div className="form-row">
//             <div className="form-register-group">
//               <label>Company Trade License <span className="required">*</span></label>
//               <div className="file-input-container">
//                 <div className="choose-file-container">
//                   <span className="file-name">{formData.companyTradeLicense ? formData.companyTradeLicense.name : "No file selected"}</span>
//                 </div>
//                 <label className="custom-file-label" htmlFor="pan-upload">Choose File</label>
//                 <input id="pan-upload" type="file" name="companyTradeLicense" onChange={handleFileChange} required />
//               </div>
//             </div>
//             <div className="form-register-group">
//               <label>VAT Registration Number</label>
//               <input type="text" name="vatRegistrationNumber" value={formData.vatRegistrationNumber} onChange={handleInputChange} />
//             </div>
//           </div>
//             <div className="form-row">
//              <div className="form-register-group">
//                <label>Online OTAs you are working with? </label>
//                <input type="text" name="onlineOTAs" value={formData.onlineOTAs} placeholder='Online OTA1' onChange={handleInputChange} />
//              </div>
//              <div className="form-register-group">
//                <label>Series OTAs you are working with? </label>
//                <input type="text" name="seriesOTAs" value={formData.seriesOTAs} placeholder='Series OTA1' onChange={handleInputChange} />
//              </div>
//            </div>
//           {/* More fields and rows if needed... */}

//           <button type="submit" className="submit-button" disabled={isSubmitting}>
//             {isSubmitting ? 'Submitting...' : 'Submit'}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default RegisterAdmin;
import React, { useState, useEffect } from 'react';
import { Country, State, City } from "country-state-city";
import '../Styles/RegisterAdmin.css';
import axios from 'axios';

const RegisterAdmin = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    fullName: '',
    phoneNumber: '',
    whatsappNumber: '',
    emailAddress: '',
    referredBy: '',
    country: '',
    state: '',
    district: '',
    city: '',
    address: '',
    locality: '',
    primaryBusiness: '',
    secondaryBusiness: '',
    nearestAirport: '',
    monthlyBusiness: '',
    secondaryMonthlyBusiness: '',
    companyTradeLicense: null,
    vatRegistrationNumber: '',
    onlineOTAs: '',
    seriesOTAs: '',
  });

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const allCountries = Country.getAllCountries();
    setCountries(allCountries);
  }, []);

  const handleCountryChange = (e) => {
    const selectedCountryCode = e.target.value;
    setFormData({ ...formData, country: selectedCountryCode, state: '', city: '' });
    const selectedStates = State.getStatesOfCountry(selectedCountryCode);
    setStates(selectedStates);
    setCities([]);
  };

  const handleStateChange = (e) => {
    const selectedStateCode = e.target.value;
    setFormData({ ...formData, state: selectedStateCode, city: '' });
    const selectedCities = City.getCitiesOfState(formData.country, selectedStateCode);
    setCities(selectedCities);
  };

  const handleCityChange = (e) => {
    setFormData({ ...formData, city: e.target.value });
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    const file = files[0];
    setFormData({
      ...formData,
      [name]: file || null,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');

    if (
      formData.vatRegistrationNumber &&
      !/^[a-zA-Z0-9]+$/.test(formData.vatRegistrationNumber)
    ) {
      alert("VAT Registration Number should contain only letters and numbers.");
      setIsSubmitting(false);
      return;
    }

    const submitData = new FormData();
    for (const key in formData) {
      if (key === 'companyTradeLicense') {
        if (formData[key]) {
          submitData.append(key, formData[key]);
        } else {
          alert(`Company Trade License is required.`);
          setIsSubmitting(false);
          return;
        }
      } else {
        submitData.append(key, formData[key]);
      }
    }

    try {
      const response = await axios.post(
        'https://b2bdubaibackendapi.mmstourism.com/api/b2/agency/register-agency',
        submitData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (formData.phoneNumber === response.data.phoneNumber) {
        setMessage('Company already exists with this phone number.');
        setIsSubmitting(false);
        return;
      }

      if (response.data?.error === 'Company already exists') {
        alert('Company already exists.');
        setIsSubmitting(false);
        return;
      }

      alert('Registration successful!');
      setFormData({
        companyName: '',
        fullName: '',
        phoneNumber: '',
        whatsappNumber: '',
        emailAddress: '',
        referredBy: '',
        country: '',
        state: '',
        district: '',
        city: '',
        address: '',
        locality: '',
        primaryBusiness: '',
        secondaryBusiness: '',
        nearestAirport: '',
        monthlyBusiness: '',
        secondaryMonthlyBusiness: '',
        companyTradeLicense: null,
        vatRegistrationNumber: '',
        onlineOTAs: '',
        seriesOTAs: '',
      });
    } catch (error) {
      alert('Company already exists.');
      console.error('API Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="register-body">
      <div className="registration-form">
        <h2>Agency Sign Up Form</h2>
        <p className="note">Fields marked with <span className="required">*</span> are mandatory</p>
        <form onSubmit={handleSubmit}>
          {/* All your form rows and fields here */}
             <div className="form-row">
            <div className="form-register-group">
               <label>Company Name <span className="required">*</span></label>
               <input type="text" name="companyName" value={formData.companyName} onChange={handleInputChange} required />
             </div>
             <div className="form-register-group">
               <label>Full Name <span className="required">*</span></label>
               <input type="text" name="fullName" value={formData.fullName} onChange={handleInputChange} required />
             </div>
           </div>
           <div className="form-row">
             <div className="form-register-group">
               <label>Phone Number <span className="required">*</span></label>
               <input type="text" name="phoneNumber" value={formData.phoneNumber} onChange={handleInputChange} required />
             </div>
             <div className="form-register-group">
               <label>WhatsApp Number <span className="required">*</span></label>
               <input type="text" name="whatsappNumber" value={formData.whatsappNumber} onChange={handleInputChange} required />
             </div>
           </div>

           <div className="form-row">
             <div className="form-register-group">
               <label>Email Address <span className="required">*</span></label>
               <input type="email" name="emailAddress" value={formData.emailAddress} onChange={handleInputChange} required />
             </div>
             <div className="form-register-group">
               <label>Referred By <span className="required">*</span></label>
               <select name="referredBy" value={formData.referredBy} onChange={handleInputChange} required>
                 <option value="">Select</option>
                 <option value="agency">Agency</option>
                 <option value="website">Website</option>
               </select>
             </div>
           </div>

           <div className="form-row">
             <div className="form-register-group">
               <label>Country <span className="required">*</span></label>
               <select name="country" value={formData.country} onChange={handleCountryChange} required>
                 <option value="">Select Country</option>
                 {countries.map((country) => (
                   <option key={country.isoCode} value={country.isoCode}>
                     {country.name}
                   </option>
                 ))}
               </select>
             </div>
             <div className="form-register-group">
               <label>State <span className="required">*</span></label>
               <select name="state" value={formData.state} onChange={handleStateChange} required>
                 <option value="">Select State</option>
                 {states.map((state) => (
                   <option key={state.isoCode} value={state.isoCode}>
                     {state.name}
                   </option>
                 ))}
               </select>
             </div>
             <div className="form-register-group">
               <label>City <span className="required">*</span></label>
               <select name="city" value={formData.city} onChange={handleCityChange} required>
                 <option value="">Select City</option>
                 {cities.map((city) => (
                   <option key={city.name} value={city.name}>
                     {city.name}
                   </option>
                 ))}
               </select>
             </div>
           </div>

           {/* Continue with other form fields here as in your original code... */}
          
            <div className="form-row">
              <div className="form-register-group">
                <label>Address <span className="required">*</span></label>
                <input type="text" name="address" value={formData.address} placeholder='Address'onChange={handleInputChange} required />
              </div>
              <div className="form-register-group">
                <label>Specify your locality <span className="required">*</span></label>
                <input type="text" name="locality" value={formData.locality} placeholder='Locality'onChange={handleInputChange} required />
              </div>
           
            </div>
            <div className="form-row">
              <div className="form-register-group">
                <label>Primary Business<span className="required">*</span></label>
                <select type="text" name="primaryBusiness" value={formData.primaryBusiness} onChange={handleInputChange} required >
                  <option value = "">Select Primary Business Type</option>
                  <option value = "Flight Ticket">Flight Ticket</option>
                  <option value = "Railway Ticket">Railway Ticket</option>
                  <option value = "Domestic Tour">Domestic Tour</option>
                  <option value = "International Tour">International Tour</option>
                </select>
              </div>
              <div className="form-register-group">
                <label>Monthly Business 
                  <span className="required">*</span>
                </label>
                <select name="monthlyBusiness" value={formData.monthlyBusiness} onChange={handleInputChange} required >
                  <option value ="">Select</option>
                  <option value ="Below USD 5000/-">Below USD 5000/-</option>
                  <option value ="USD 5000/-TO 15000/-">USD 5000/-TO 15000/-</option>
                  <option value ="USD 15000/-TO 25000/-">USD 15000/-TO 25000/-</option>
                  <option value ="Above 25000/- AND ABOVE">Above 25000/- AND ABOVE</option>
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-register-group">
                <label>Secondary Business
                  {/* <span className="required">*</span> */}
                  </label>
                <select type="text" name="secondaryBusiness" value={formData.secondaryBusiness} onChange={handleInputChange}>
                  <option value = "">Select Secondary Business Type</option>
                  <option value = "Flight Ticket">Flight Ticket</option>
                  <option value = "Railway Ticket">Railway Ticket</option>
                  <option value = "Domestic Tour">Domestic Tour</option>
                  <option value = "International Tour">International Tour</option>
                  <option value = "none">None</option>
                </select>
              </div>
              <div className="form-register-group">
                <label>Monthly Business
                   {/* <span className="required">*</span> */}
                   </label>
                <select name="secondaryMonthlyBusiness" value={formData.secondaryMonthlyBusiness} onChange={handleInputChange}  >
                  <option value ="">Select</option>
                  {/* <option value ="Below 5 lacs">Below 5 Lacs</option>
                  <option value ="5 - 10 Lacs">5 - 10 Lacs</option>
                  <option value ="11 - 25 Lacs">11 - 25 Lacs</option>
                  <option value ="Above 25 Lacs">Above 25 Lacs</option> */}
                   <option value ="Below USD 5000/-">Below USD 5000/-</option>
                <option value ="USD 5000/-TO 15000/-">USD 5000/-TO 15000/-</option>
                  <option value ="USD 15000/-TO 25000/-">USD 15000/-TO 25000/-</option>
                  <option value ="Above 25000/- AND ABOVE">Above 25000/- AND ABOVE</option>
                </select>
              </div>
           </div>
          <div className="form-row">
            <div className="form-register-group">
              <label>Company Trade License <span className="required">*</span></label>
              <div className="file-input-container">
                <div className="choose-file-container">
                  <span className="file-name">{formData.companyTradeLicense ? formData.companyTradeLicense.name : "No file selected"}</span>
                </div>
                <label className="custom-file-label" htmlFor="pan-upload">Choose File</label>
                <input id="pan-upload" type="file" name="companyTradeLicense" onChange={handleFileChange} required />
              </div>
            </div>
            <div className="form-register-group">
              <label>VAT Registration Number</label>
              <input
                type="text"
                name="vatRegistrationNumber"
                value={formData.vatRegistrationNumber}
                onChange={handleInputChange}
                placeholder="E.g., TRN123456789 or DE123456789"
              />
            </div>
          </div>
           <div className="form-row">
              <div className="form-register-group">
                <label>Online OTAs you are working with? </label>
                <input type="text" name="onlineOTAs" value={formData.onlineOTAs} placeholder='Online OTA1' onChange={handleInputChange} />
              </div>
              <div className="form-register-group">
                <label>Series OTAs you are working with? </label>
                <input type="text" name="seriesOTAs" value={formData.seriesOTAs} placeholder='Series OTA1' onChange={handleInputChange} />
              </div>
            </div>

          {/* Add all other fields you already had here in similar format */}

          <button type="submit" className="submit-button" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RegisterAdmin;
